<template>
  <DModal :showClose="false" :isBgOverlay="true" @close="$emit('close')" style="z-index: 112313123">
    <div class="d-modal d-modal__opus" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Data fra KMD OPUS for {{ user.v_user_name }}</h2>
        <div class="d-modal__header__right">
          <div class="icon__bg-circle no-print" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
        </div>
      </div>
      <div class="d-modal__content">
        <Loader v-if="isLoading" bg-color="#f6f9fc"></Loader>
        <template v-else>
          <h3>
            For perioden {{ titleOfPeriod }}
          </h3>
          <h4 class="text-explainer" v-if="oneTimePayments.length === 0">Ingen data for perioden</h4>
          <table class="do-table" v-if="oneTimePayments.length > 0">
            <thead>
            <tr>
              <th v-for="(value, key) in oneTimePayments[0]" :key="key">
                {{ key.replace('_', ' ') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="payment in oneTimePayments" :key="payment.id">
              <td v-for="(value, key) in payment" :key="key">
                {{ value || '-' }}
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import docendo from '../../docendo'
import moment from 'moment'
import Loader from '../common/Loader.vue'
import eventbus from '../../eventbus'
export default {
  components: {Loader, DModal},
  props: {
    user: {
      type: Object
    },
    startDate: {
      default: () => moment().startOf('month')
    },
    endDate: {
      default: () => moment().endOf('month')
    },
    schoolId: {
      default: null
    }
  },
  data () {
    return {
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      opusData: [],
      isLoading: false
    }
  },
  computed: {
    titleOfPeriod () {
      if (!this.startDate || !this.endDate) return 'Ingen periode valgt'
      return `${moment(this.startDate).format('LL')} - ${moment(this.endDate).format('LL')}`
    },
    oneTimePayments () {
      if (!this.opusData || !this.opusData.one_time_payments) {
        return []
      } else {
        return this.opusData.one_time_payments.sort((a, b) =>
          new Date(a.startdato) - new Date(b.startdato)
        )
      }
    }
  },
  methods: {
    readOpus () {
      this.isLoading = true
      const schoolIds = [this.schoolId]
      docendo.salaryOpusRead(this.schoolId, schoolIds, this.fromDate, this.toDate, this.user.user_id, success => {
        this.opusData = success
        this.isLoading = false
        console.log('opus', success)
      }, failure => {
        console.log(failure)
        eventbus.toast = {text: failure.error, success: false}
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.fromDate = moment(this.startDate).format('YYYY-MM-DD')
    this.toDate = moment(this.endDate).format('YYYY-MM-DD')
    this.readOpus()
  }
}
</script>

<style scoped>

.d-modal__opus {
  width: 100%;
  max-width: 1200px;
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// SalarySubsPerfUserOpusModal.vue?38bbdf7f